/*
 * PDP 赠品项的「变体维度」联动（用户 2026-09-28 裁决 Q2）。
 *
 * 背景：赠品卡元对象 vl_product_free_gift 的作用范围三档（variant_list > product_list > collection）中，
 *   只有 variant_list 是**变体维度**。用户要求：切到范围外的变体时，PDP 的赠品项
 *   ① 不再展示 ② 也不会随主商品加入购物车。
 *
 * 实现：服务端（snippets/vl-product-free-gift.liquid, view: 'pdp'）已按「当前变体」渲染好初始态，
 *   并输出 <script type="application/json" data-vl-free-gift-scope>{"variantDimension":bool,"variants":[ids]}</script>；
 *   本脚本在变体切换后按当前变体重新判定，切换赠品项的 hidden 与加购类（acc-checkbox）。
 *   加购收集逻辑在 assets/bundle.js：`.bundle-container` 内 `.checkbox-input.acc-checkbox:checked`
 *   —— 摘掉该类即同时移出加购请求（不需要改 bundle.js）。
 *
 * 兜底：无 scope JSON（未命中赠品卡 / 展示类项）时脚本直接返回，零副作用。
 */
(function () {
  if (window.__vlFreeGiftPdpReady) return;
  window.__vlFreeGiftPdpReady = true;

  function readScope() {
    var el = document.querySelector('[data-vl-free-gift-scope]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || '{}');
      if (!data || typeof data !== 'object') return null;
      return data;
    } catch (error) {
      console.error('[vl-free-gift] scope JSON 解析失败', error);
      return null;
    }
  }

  function currentVariantId() {
    var input = document.querySelector(
      '.product-form-wrap input[name="id"], form[data-type="add-to-cart-form"] input[name="id"], input[data-product-form-variant][name="id"]'
    );
    return input ? String(input.value || '') : '';
  }

  function apply() {
    var scope = readScope();
    if (!scope) return;
    var items = document.querySelectorAll('[data-vl-gift-kind]');
    if (!items.length) return;

    var inScope = true;
    if (scope.variantDimension) {
      var allowed = Array.isArray(scope.variants) ? scope.variants.map(String) : [];
      inScope = allowed.indexOf(currentVariantId()) !== -1;
    }
    var currentId = currentVariantId();

    Array.prototype.forEach.call(items, function (item) {
      var kind = item.getAttribute('data-vl-gift-kind');
      var visible = inScope;
      if (kind === 'product-dimension') {
        var dataEl = item.querySelector('script[data-vl-product-gift-variants]');
        var variants = [];
        try {
          variants = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];
        } catch (error) {
          console.error('[vl-free-gift] product gift JSON 解析失败', error);
        }
        var match = null;
        variants.some(function (variant) {
          var mainVariants = Array.isArray(variant.mainVariants) ? variant.mainVariants.map(String) : [];
          if (mainVariants.indexOf(currentId) === -1) return false;
          match = variant;
          return true;
        });
        visible = !!(inScope && match);
        if (visible) {
          item.setAttribute('data-variant', match.id);
          var image = item.querySelector('[data-vl-product-gift-image]');
          if (image) {
            image.hidden = !match.image;
            if (match.image) image.setAttribute('src', match.image);
          }
          var price = item.querySelector('[data-vl-product-gift-price]');
          if (price) price.textContent = match.priceMoney;
          var priceLabel = item.querySelector('[data-vl-product-gift-price-label]');
          if (priceLabel) {
            priceLabel.setAttribute(
              'aria-label',
              'Free ' + match.title + ', worth ' + match.priceMoney + ', checked'
            );
          }
        }
      }
      item.hidden = !visible;

      if (kind === 'product' || kind === 'product-dimension') {
        var checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox) {
          /* 变体类/产品维度赠品固定入车；展示类永远保持 acc-checkbox-2。 */
          checkbox.classList.toggle('acc-checkbox', visible);
          checkbox.classList.toggle('acc-checkbox-2', !visible);
          checkbox.checked = visible;
        }
      }
    });

    /* 三个来源合计最多显示 4 个赠品，超出按 DOM 顺序隐藏。 */
    var visibleGifts = 0;
    Array.prototype.forEach.call(items, function (item) {
      if (item.hidden) return;
      visibleGifts += 1;
      if (visibleGifts <= 4) return;
      item.hidden = true;
      var checkbox = item.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.classList.remove('acc-checkbox');
        checkbox.classList.add('acc-checkbox-2');
        checkbox.checked = false;
      }
    });
  }

  /* 变体切换：主题的 variant picker 以 change 事件驱动（radio/select），捕获阶段 + 下一帧保证读到更新后的 input 值 */
  document.addEventListener(
    'change',
    function () {
      window.requestAnimationFrame(apply);
    },
    true
  );
  document.addEventListener('shopify:section:load', apply);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
